var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.isEmpty)?_c('span',{staticClass:"flex items-center"},[_c('icon',{staticClass:"text-sm mr-1",class:_vm.processStateIcon,attrs:{"name":"bold/check-circle-1"}}),_c('span',[_vm._v(_vm._s(_vm.processState))])],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }